async function prepareCalendar(dateString){
  window.EventsAddedOnCalendarButtons = false;
  const validateTime = await validateCurrentTime();
  const effectiveTodaysDate = validateTime ? await fetchCurrentDate() : await fetchNextDate();
  let [ selectedDay, selectedDate, daysInMonth, firstDayPosition, currentDay ] = [dayjs(dateString), dayjs(dateString).date(), dayjs(dateString).daysInMonth(), (dayjs(dateString).startOf("month").day() + 6) % 7 + 1, dayjs(effectiveTodaysDate)];
  let monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  let weekNames = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  let dateElement = document.querySelector("#calendarPiker .calendar-dates");
  let calendarTitle = document.querySelector(".calendar-title-text");
  let nextMonthButton = document.querySelector("#nextMonth");
  let prevMonthButton = document.querySelector("#prevMonth");
  let dayNamesElement = document.querySelector(".calendar-day-name");
  let dateItems = null;
  let newMonth = null;

  dayNamesElement.innerHTML = '';
  weekNames.forEach(function (item) {
    dayNamesElement.innerHTML += `<div>${item}</div>`;
  });

  async function fetchNextDate(){
    const todaysDate = await fetchCurrentDate();
    const tomorrowsDate = await getNextDay(todaysDate);
    return tomorrowsDate;
  }

  async function plotDays() {
    let count = 1;
    dateElement.innerHTML = "";
    let year = selectedDay.year();
    let month = selectedDay.month() + 1;

    let prevMonthLastDate = selectedDay.subtract(1, "month").endOf("month").$D;
    let prevMonthDateArray = [];

    for (let p = 1; p < firstDayPosition; p++) {
      prevMonthDateArray.push(prevMonthLastDate--);
    }
    prevMonthDateArray.reverse().forEach(function (day) {
      let fullDate = `${year}-${String(month - 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      dateElement.innerHTML += `<button class="calendar-dates-day-empty" data-date="${fullDate}">${day}</button>`;
    });

    for (let i = 0; i < daysInMonth; i++) {
      let fullDate = `${year}-${String(month).padStart(2, '0')}-${String(count).padStart(2, '0')}`;
      dateElement.innerHTML += `<button class="calendar-dates-day" data-date="${fullDate}">${count++}</button>`;
    }

    let diff = 42 - Number(document.querySelector(".calendar-dates").children.length);
    let nextMonthDates = 1;
    for (let d = 0; d < diff; d++) {
      let fullDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(nextMonthDates).padStart(2, '0')}`;
      document.querySelector(
        ".calendar-dates"
      ).innerHTML += `<button class="calendar-dates-day-empty" data-date="${fullDate}">${nextMonthDates++}</button>`;
    }

    calendarTitle.innerHTML = `${
      monthNames[selectedDay.month()]
    } - ${selectedDay.year()}`;
    setTimeout(addDayToCalendarDate, 100)
    const validateTime = await validateCurrentTime(); 
    console.log(validateTime, 'validateTime');
  }

  function addDayToCalendarDate(){
    dateElement.querySelectorAll('.calendar-dates-day').forEach(button => {
      const date = button.dataset.date;
      const day = dayjs(date).day() == 0 ? 7 : dayjs(date).day();
      button.classList.add(`day--${day}`);
    });
  }

  function handleDayClick(event) {
    const selectedDateISO = event.target.getAttribute('data-date');
    if (!selectedDateISO) return;

    document.querySelectorAll('.calendarPiker .calendar-dates-day').forEach(day => {
      day.classList.remove('picked'); 
      day.classList.remove('today-date'); 
    });
    dateString = event.target.dataset.date;

    [selectedDay, selectedDate, selectedMonth, daysInMonth, firstDayPosition ] = [dayjs(dateString), dayjs(dateString).date(), dayjs(dateString).month(), dayjs(dateString).daysInMonth(), (dayjs(dateString).startOf("month").day() + 6) % 7 + 1];

    event.target.classList.add('picked');
    let formattedDate = dayjs(selectedDateISO).format('DD/MM/YYYY');

    const giftScheduleDate = document.getElementById('giftScheduleDate');
    giftScheduleDate.innerHTML = `${window.FutureDateSelectedText} <span>${formattedDate}</span>`;
    console.log('calender.js');
    $('#next-stage-button-1').show().removeClass('inactive');
    $('#delivery-type-error').text('');
  }

  if(dateString){
    isSameMonth = dayjs().month() == dayjs(dateString).month();
    if(!isSameMonth) prevMonthButton.classList.remove('disabled');
  }

  async function highlightCurrentDate() {
    const isSameMonth = selectedDay.month() == currentDay.month();
    dateItems = document.querySelectorAll(".calendar-dates-day");
    dateItems.forEach(function (dateButton, index) {
      dateButton.classList.remove("disabled");
      if(isSameMonth && (index < currentDay.date() - 1)) dateButton.classList.add("disabled");
      if (index === selectedDate - 1 && dateButton.dataset.date == dateString) {
        dateButton.classList.add("today-date");
        const formattedDate = dayjs(dateString).format('DD/MM/YYYY')
        const giftScheduleDate = document.getElementById('giftScheduleDate');
        giftScheduleDate.innerHTML = `${window.FutureDateSelectedText} <span>${formattedDate}</span>`;
      }
    });
  }

  if(!window.EventsAddedOnCalendarButtons){
    window.EventsAddedOnCalendarButtons = true; 
    // calendar button event
    dateElement.addEventListener('click', function(event) {
      if (event.target.classList.contains('calendar-dates-day')) handleDayClick(event);
    });
    //prev month button event
    prevMonthButton.addEventListener("click", prevMonthButtonEvent);  
    //next month button event
    nextMonthButton.addEventListener("click", nextMonthButtonEvent);  
  }
  
  function nextMonthButtonEvent() {
    prevMonthButton.classList.remove("disabled");
    newMonth = selectedDay.add(1, "month").startOf("month");
    setSelectedMonth();
    setTimeout(highlightCurrentDate, 50);
  }

  function prevMonthButtonEvent(){
    if (selectedDay.subtract(1, "month").isSame(dayjs(), "month")) {
        newMonth = dayjs();
        setSelectedMonth();
        prevMonthButton.classList.add("disabled");
      } else {
        prevMonthButton.classList.remove("disabled");
        newMonth = selectedDay.subtract(1, "month").startOf("month");
        setSelectedMonth();
      }
      setTimeout(highlightCurrentDate, 50);
    }

  function setSelectedMonth() {
    daysInMonth = newMonth.daysInMonth();
    firstDayPosition = (newMonth.startOf("month").day() + 6) % 7 + 1;
    selectedDay = newMonth;
    plotDays();
  }

  plotDays();
  setTimeout(highlightCurrentDate, 1000);
}
window.addEventListener('load', () => prepareCalendar())